<template lang="html">
  <div class="domain-help">
    <Guide
      :content="content"
      contentHeading="Domain Title"
      :contentVideo="contentVideo"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'DomainRequestForm',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'domain-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'previous-link-here',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'next-link-here',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You're eligible for a new domain name. Request one!</p>
      `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/8++-+COMPUTOR_03.mp4'
    }
  }
}
</script>
